export default {
    env: { // 环境判断
        beta: {
            domain: 'test.i.meituan.com', // 当前域名
            serverDomain: 'queue.test.meituan.com/api', // 当前后端域名
            // serverDomain: 'localhost:8080/api', // 本地调试使用
            rmsDomain: 'rms.sjst.test.meituan.com',
            setLoginCookie: 'm.51ping.com/orderdish/invoice/login/setcookie',
            kdbSSO: 'http://fepassport.sjst.test.sankuai.com/account/unitivelogin?bg_source=1&service=orderdish-invoice-web&continue=',
        },
        prd: {
            domain: 'i.meituan.com',
            serverDomain: 'queue.meituan.com/api',
            rmsDomain: 'pos.meituan.com',
            setLoginCookie: 'm.dianping.com/orderdish/invoice/login/setcookie',
            kdbSSO: 'https://epassport.meituan.com/account/unitivelogin?bg_source=1&service=orderdish-invoice-web&continue=',
        },
    },
};



// WEBPACK FOOTER //
// ./lib/config.js